import { Search as SerendieSearch } from "@serendie/ui";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { JSX } from "react";
import "./Styles.scss";
import { Guid } from "@iconics/core";
import { HelperText } from "../../Typography/HelperText/HelperText";

export class SearchBox extends BaseComponent<ISearchBoxProps, ISearchBoxState>
{
    private inputId = Guid.new().toString().toLowerCase();
    private collection: any = {};
    constructor(props: ISearchBoxProps)
    {
        super(props);
        this.state =
        {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div
                className='serendie-search'
            >
                <label
                    htmlFor={`menu:${this.inputId}:trigger`}
                    className='serendie-search__label'
                >
                    {this.props.label}
                    {
                        this.props.required &&
                        <span
                            className='serendie-search__required'
                        >
                            {this.props.requiredLabel ?? "*"}</span>
                    }
                </label>
                <SerendieSearch
                    id={this.inputId}
                    {...this.props}
                    className={`
                        serendie-search__component
                        ${this.props.invalid ? 'serendie-search__invalid' : ''}
                        ${this.props.className}`
                    }
                    invalid={this.props.invalid}
                    collection={this.collection} // this prop is required by the component but undocumented on serendies docs
                // doesn't seem to do anything - its type cannot be imported - probably a bug?
                />
                {this.props.invalid && this.props.invalidMessage &&
                <div className="serendie-search__invalidMessage">
                    <HelperText error={true}>
                        {this.props.invalidMessage}
                    </HelperText>
                </div>
                }
            </div>
        )
    }
}

export interface ISearchBoxProps extends Omit<React.ComponentProps<typeof SerendieSearch>, 'collection'>
{
    label?: string;
    requiredLabel?: string;
    invalidMessage?: string;
}

export interface ISearchBoxState
{
}
